import React from "react";
import "./index.css";
import Textarea from "../../../layout/Textarea/Textarea";
import ImageUpload from "../../../layout/ImageUpload/index";
import BgTransformer from "../../../layout/BgTransformer";
import {logoBlackMinimal} from "../../../data/constants";
import {withDeployVersion} from "../../../libs/deployVersion";
import {useSetting} from "../../../contexts/setting";
import {useEdits} from "../../../contexts/edits";
import {useBgUrl} from "hooks/useBgUrl";

const YouTubeThumbnailWebinar = ({id, zoom}) => {
  const {type} = useSetting();
  const {url: bgUrl} = useBgUrl();
  const {titles, names, positions, subtitles, subtitles2, subtitles3, dates} = useEdits();

  const title = titles[id] || titles.main;
  const eventSubtitle = subtitles3[id] || subtitles3.main;
  const name = names[id] || names.main;
  const position = positions[id] || positions.main;
  const speakerName2 = subtitles[id] || subtitles.main;
  const speakerTitle2 = subtitles2[id] || subtitles2.main;
  const date = dates[id] || dates.main;

  return (
    <div id={id} className={`template ${type.value}`} style={{"--zoom-level": zoom}}>
      <div className="template-inner">
        <BgTransformer src={bgUrl} id={id} />
        <header className="template-header">
          <div className="header-logo">
            <img src={withDeployVersion(logoBlackMinimal)} alt="JetBrains" />
          </div>
          <div className="product-name">{type.altLabel || type.label}</div>
          <div className="livestream-label">Webinar</div>
        </header>

        <div className="title-wrap">
          <h1 className="title">
            <Textarea id={id} text={title} />
          </h1>
          <div className="subtitle3">
            <Textarea id={id} text={eventSubtitle} />
          </div>
          <div className="date">
            <Textarea id={id} text={date} />
          </div>
        </div>

        <div className="speaker-photo speaker-photo-1">
          <ImageUpload id="speaker-1" imageKey="speaker-1" transformKey={`${id}-speaker-1`} />
        </div>
        <div className="speaker-photo speaker-photo-2">
          <ImageUpload id="speaker-2" imageKey="speaker-2" transformKey={`${id}-speaker-2`} />
        </div>

        <div className="speaker-info speaker-info-1">
          <div className="name">
            <Textarea id={id} text={name} />
          </div>
          <div className="position">
            <Textarea id={id} text={position} />
          </div>
        </div>

        <div className="speaker-info speaker-info-2">
          <div className="subtitle">
            <Textarea id={id} text={speakerName2} />
          </div>
          <div className="subtitle2">
            <Textarea id={id} text={speakerTitle2} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default YouTubeThumbnailWebinar;
